export default __webpack_public_path__ + "static/media/3049.7316a26c.jpg";